
// src/helpers/sanitize-html.js

import DOMPurify from 'dompurify'

const DOMPurifyCONFIG = {
  ALLOWED_TAGS: ['div', 'p', 'ol', 'ul', 'li', 'br', 'span', 'b', 'i', 'u', 'img', 'svg', '#text', 'h1', 'h2', 'h3', 'a', 'input'],
  ALLOWED_ATTR: ['style', 'src', 'target', 'contenteditable', 'href', 'class', 'type', 'value', 'checked', 'name', 'id'],
  ALLOW_DATA_ATTR: false,
  KEEP_CONTENT: true,
  ADD_TAGS: false,
  ADD_ATTR: false,
  WHOLE_DOCUMENT: false,
  RETURN_DOM: true,
  RETURN_DOM_FRAGMENT: true
}

DOMPurify.addHook('uponSanitizeElement', function(node, data) {
  var tagName = node.nodeName.toLowerCase()
  if (tagName == 'img') {
    // 絵文字以外のimgタグは削除する
    var src = node.getAttribute('src')
    if (!src.match(/\/emojione\/.+\.(png|svg)$/)) {
      node.parentNode.removeChild(node)
    }
  }
  else if (tagName == 'h1' || tagName == 'h2' || tagName == 'h3') {
    var element = document.createElement('div')
    element.innerHTML = '<b>' + node.innerText + '</b>'
    node.parentNode.insertBefore(element, node)
    node.parentNode.removeChild(node)
  }
  else if (tagName == 'a') {
    if (node.className == 'googleDoc' || node.className == 'gambaUrl') {
      var element = node.cloneNode(true)
      element.setAttribute('contenteditable', false)
      element.setAttribute('target', '_blank')
      element.setAttribute('rel', 'noopener noreferrer')
      node.parentNode.insertBefore(element, node)
      node.parentNode.removeChild(node)
    } else {
      var element = document.createElement('a')
      var href = node.getAttribute('href')
      element.innerHTML = href
      element.setAttribute('href', href)
      element.setAttribute('contenteditable', false)
      element.setAttribute('target', '_blank')
      element.setAttribute('rel', 'noopener noreferrer')
      node.parentNode.insertBefore(element, node)
      node.parentNode.removeChild(node)
    }
  }
  else if (tagName == 'input') {
    var element = node.cloneNode(true)
    element.setAttribute('type', element.getAttribute('type') || 'button')
    element.id = Math.random().toString().slice(2)
    element.removeAttribute('disabled')

    var span = document.createElement('span')
    span.setAttribute('contenteditable', 'false')
    span.appendChild(element)

    node.parentNode.insertBefore(span, node)
    node.parentNode.removeChild(node)
  }
})

DOMPurify.addHook('uponSanitizeAttribute', function(node, data) {
  if (data.attrName == 'style') {
    if (node.nodeName.toLowerCase() == 'span') {
      var result = data.attrValue.match(/(background(-color)?: ?rgb\(255, ?255, ?119\);?|color: ?rgb\(255, ?0, ?0\);?)/)
      if (result) {
        return data.attrValue = result[1]
      }
      else {
        return data.attrValue = ''
      }
    }
    else if (node.nodeName.toLowerCase() == 'img')
      return data
    else
      return data.attrValue = ''
  } else if (data.attrName == 'class') {
    if (node.nodeName.toLowerCase() != 'a' || data.attrValue != 'googleDoc')
      data.attrValue = ''
    return data
  }
})

function stripDiv(node) {
  if (node.nodeName.toLowerCase() == 'div' && node.childNodes.length == 1)
    return stripDiv(node.childNodes[0])
  else
    return node.parentNode
}

export default function(html, isPaste, self) {
  var result = html ? DOMPurify.sanitize(html, DOMPurifyCONFIG) : null
  return result ? self._doc.importNode(result, true) : self._doc.createDocumentFragment()
}



// WEBPACK FOOTER //
// ./src/helpers/sanitize-html.js